export default __webpack_public_path__ + "static/media/black_illusHeader_tall375.157ab1cf.png";